import axios from 'axios';

const academicService = axios.create({
  baseURL: process.env.REACT_APP_ACADEMIC_URL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});
export default academicService;
